import { forwardRef, useCallback, useEffect, useRef, useState } from "react";

import styled from "styled-components/macro";
import { padding } from "theme";

import FnrTypography from "FnrTypography/FnrTypography";
import classNames from "classnames";
import { motion } from "framer-motion";

import FnrFade from "UI/FnrFade/FnrFade";
import FnrIcon from "UI/FnrIcon";
import FnrIconButton from "UI/FnrIconButton/FnrIconButton";
import FnrInput2 from "UI/FnrInput2/FnrInput2";
import { colors } from "UI/colors";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap/FnrHorizontalGap";

const SDiv = styled("div")`
  width: 100%;
  white-space: nowrap;
`;

const SFnrHorizontalGap = styled(FnrHorizontalGap)`
  ${padding}
`;

const FnrNumberButtons = forwardRef(
  (
    {
      value: valueArg,
      min = 0,
      max,
      maxButtonsValue = 9,
      setValue,
      onBlur: onBlurArg,
      ...rest
    },
    refArg
  ) => {
    const value = Number(valueArg);
    const localRef = useRef();
    const ref = refArg || localRef;
    const [showButtons, setShowButtons] = useState(value <= maxButtonsValue);
    const [showInput, setShowInput] = useState(value > maxButtonsValue);

    useEffect(() => {
      if (value > maxButtonsValue && showButtons) {
        setShowButtons(false);
        setTimeout(() => {
          //   const input = ref.current.querySelector("input");
          //   input.focus();
          //   input.select();
        });
      }
    }, [maxButtonsValue, ref, value, showButtons]);

    const onBlur = useCallback(() => {
      if (onBlurArg) onBlurArg();
      if (value <= maxButtonsValue) setShowInput(false);
    }, [maxButtonsValue, onBlurArg, value]);

    return (
      <SDiv ref={ref}>
        {/* <FnrFade
          show={showInput}
          top
          onAnimationComplete={({ opacity }) => {
            if (!opacity) setShowButtons(true);
          }}
        >
          <FnrInput2
            type="number"
            min={min}
            max={max}
            value={valueArg}
            setValue={setValue}
            onBlur={onBlur}
            {...rest}
          />
        </FnrFade> */}
        <ButtonsWrapper>
          <PlusMinusButton
            icon="fa-minus fa"
            onClick={() => setValue(value - 1)}
            aria-label="minus-button"
            disabled={value <= min}
          />
          <Value>{value}</Value>
          <PlusMinusButton
            icon="fa-plus fa"
            onClick={() => setValue(value + 1)}
            aria-label="plus-button"
          />
        </ButtonsWrapper>
      </SDiv>
    );
  }
);

export default FnrNumberButtons;

const Value = styled.div`
  font-size: 26px;
  font-weight: 400;
  padding-top: 1px;
  min-width: 32px;
  text-align: center;
`;
const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  font-variant-numeric: tabular-nums;
`;

const PlusMinusButton = ({ disabled, onClick, icon }) => {
  return (
    <Button
      className={classNames({ disabled })}
      onClick={!disabled ? onClick : null}
      type="button"
    >
      <PlusMinusWrapper>
        <FnrIcon icon={icon} />
      </PlusMinusWrapper>
    </Button>
  );
};

const Button = styled.button`
  cursor: pointer;
  background: transparent;
  border: none;
  padding: 10px 3px;

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const PlusMinusWrapper = styled.div`
  background: ${colors.fnGray};
  border: none;
  width: 18px;
  height: 18px;
  font-size: 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  box-sizing: border-box;
  color: #fff;
  padding-top: 1px;
  transition: 0.2s;

  Button:hover:not(.disabled) & {
    background: ${colors.fnBlue};
  }

  Button:active:not(.disabled) & {
    transform: scale(0.75);
    background: ${colors.fnBlue};
  }

  Button:focus:not(.disabled) & {
    background: ${colors.fnBlue};
  }
`;
